import React from "react";
import { InputNumber, Image } from "antd";
import styled from "styled-components";
// import { PlusOutlined, DeleteOutlined } from "@ant-design/icons";
import colors from "constants/palette";
export default function App({ data, handleSubmit }) {
  const [visible, setVisible] = React.useState(false);
  const [value, setValue] = React.useState(data?.amount ? data?.amount : 0);

  const images = JSON.parse(data.data).images;

  function handleBlur() {
    handleSubmit({ ...data, amount: value });
  }
  function handleFocus() {
    if (value === 0) {
      setValue("");
    }
  }
  function handleChange(newValue) {
    setValue(newValue);
  }

  return (
    <Container>
      <ImageContainer>
        <Image
          preview={{ visible: false }}
          width={72}
          height={72}
          fallback="/images/fallback.svg"
          src={
            images.length ? images[0] : "/photo-1503185912284-5271ff81b9a8.webp"
          }
          onClick={() => setVisible(true)}
        />
        {images.length ? (
          <div style={{ display: "none" }}>
            <Image.PreviewGroup
              preview={{ visible, onVisibleChange: (vis) => setVisible(vis) }}
            >
              {images.map((item, key) => (
                <Image src={item} key={key} />
              ))}
            </Image.PreviewGroup>
          </div>
        ) : null}
      </ImageContainer>

      <Title title={data.title}>{data.title}</Title>
      <InputNumber
        size="small"
        min={0}
        style={{ width: "80%", margin: "8px 10%" }}
        onBlur={handleBlur}
        onClick={handleFocus}
        value={value}
        onChange={handleChange}
        onStep={(val, info) => {
          setValue((e) => (info.type === "up" ? e + 1 : e - 1));
        }}
      />
    </Container>
  );
}
const Container = styled.div`
  border: 1px solid #c9c9c9;
  border-radius: 4px;
  min-width: 92px;
  width: 30%;
  height: 206px;
  margin: 6px auto;
  background: ${colors.white};
`;
const ImageContainer = styled.div`
  width: 100%;
  padding: 16px 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  align-content: center;
  margin-bottom: 6px;
`;
const Title = styled.div`
  /* white-space: nowrap; */
  overflow: hidden;
  text-overflow: ellipsis;
  height: 50px;
  padding: 4px 16px;
`;
